module.exports = __webpack_public_path__ + "static/media/article.5848429d.png";